"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutationProduceWrites = mutationProduceWrites;
exports.mutationReadFromCache = mutationReadFromCache;
exports.mutationWriteOutput = mutationWriteOutput;

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _mutate = require("../../utils/mutate");

var _firestore = require("firebase/firestore");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const primaryValue = arr => Array.isArray(arr) && typeof arr[0] === 'string' && arr[0].indexOf('::') === 0 ? null : arr;

const nestedMap = (obj, key, val) => {
  delete obj[key];
  const fields = key.split('.');
  fields.reduce((deep, field, idx) => {
    if (deep[field] === undefined) deep[field] = {};
    if (idx === fields.length - 1) deep[field] = val;
    return deep[field];
  }, obj);
  return obj;
};

const arrayUnion = (key, val, cached) => key !== '::arrayUnion' ? null : (cached() || []).concat([val]);

const arrayRemove = (key, val, cached) => key === '::arrayRemove' && (cached() || []).filter(item => item !== val);

const increment = (key, val, cached) => key === '::increment' && typeof val === 'number' && (cached() || 0) + val;

const serverTimestamp = key => key === '::serverTimestamp' && _firestore.Timestamp.now();

const deleteField = (key, cached) => {
  if (key === '::delete') {
    delete cached()[key];
  }
};

function atomize(mutation, cached) {
  return Object.keys(mutation).reduce((data, key) => {
    const val = data[key];

    if (key.includes('.')) {
      nestedMap(data, key, val);
    } else if (Array.isArray(val) && val.length > 0) {
      data[key] = primaryValue(val) || serverTimestamp(val[0]) || arrayUnion(val[0], val[1], () => cached(key)) || arrayRemove(val[0], val[1], () => cached(key)) || deleteField(val[0], val[1], () => cached(key)) || increment(val[0], val[1], () => cached(key));
    }

    return data;
  }, JSON.parse(JSON.stringify(mutation)));
}

function mutationReadFromCache(reads, _ref) {
  let {
    db,
    dbo
  } = _ref;
  if ((0, _isEmpty.default)(reads)) return {};
  return Object.keys(reads).reduce((result, key) => {
    if ((0, _mutate.isProviderRead)(reads[key])) {
      return { ...result,
        [key]: (0, _mutate.getRead)(reads[key])
      };
    }

    const path = reads[key] && reads[key].path || reads[key].collection;
    const id = reads[key] && reads[key].id || reads[key].doc;
    const collection = db[path] || {};
    const overrides = dbo[path] || {};
    const isQueryRead = !(0, _mutate.isDocRead)(reads[key]);

    if (isQueryRead) {
      const pathIds = processOptimistic(reads[key], {
        database: db,
        databaseOverrides: dbo
      });
      return { ...result,
        [key]: pathIds.reduce((docs, _ref2) => {
          let [path, id] = _ref2;
          const document = { ...collection[id],
            ...(overrides[id] || {})
          };
          if ((0, _isEmpty.default)(document)) return docs;
          return [...docs, {
            id,
            path,
            ...document
          }];
        }, [])
      };
    }

    const document = { ...collection[id],
      ...(overrides[id] || {})
    };
    if ((0, _isEmpty.default)(document)) return result;
    return { ...result,
      [key]: {
        id,
        path,
        ...document
      }
    };
  }, {});
}

function mutationProduceWrites(readResults, writes) {
  return writes.map(writer => (0, _isFunction.default)(writer) ? writer(readResults) : writer).filter(data => !data || !(0, _isEmpty.default)(data)).reduce((flat, result) => [...flat, ...(Array.isArray(result) ? result : [result])], []);
}

function mutationWriteOutput(writeInstructions, _ref3) {
  let {
    db
  } = _ref3;
  return writeInstructions.map(write => {
    const {
      collection,
      path,
      doc,
      id,
      data,
      ...rest
    } = write;
    const coll = path || collection;
    const docId = id || doc;
    return {
      path: coll,
      id: docId,
      ...atomize(collection ? data : rest, key => {
        const database = Object.keys(db).length > 0 ? db : {};
        const location = database[coll] || {};
        return (location[docId] || {})[key];
      })
    };
  });
}